import type { IEvidenceStatus } from '@/types/evidence'
export const EVIDENCE_STATUS: { [K in IEvidenceStatus]: string } = {
  notApplicable: 'No Aplicable',
  notStarted: 'No Iniciado',
  inProgress: 'En Curso',
  completed: 'Completado',
}

export const EVIDENCE_TABLE = {
  TITLE: 'Evidencias',
  OWNER_UPDATED: 'Responsable de evidencias actualizado',
  SEARCH_PLACEHOLDER: 'Buscar evidencias...',
}
export const EVIDENCE_COLUMN_FILTER = {
  ALL: 'Todos',
  CLEAR: 'Limpiar',
  SEARCH_PLACEHOLDER: 'Buscar...',
  NO_RESULTS: 'No se encontraron resultados.',
}
export const EVIDENCE_BULK_ACTIONS = {
  SELECTED: 'seleccionadas',
  EVIDENCE: 'evidencia',
  EVIDENCES: 'evidencias',
  UPDATING: 'Actualizando...',
  CLEAR: 'Limpiar',
}
export const EVIDENCE_OWNER_SELECTOR = {
  SELECT_OWNER: 'Seleccionar responsable',
  SEARCH_USERS: 'Buscar usuarios...',
  LOADING: 'Cargando...',
  NO_USER_FOUND: 'No se encontró ningún usuario.',
}
export const EVIDENCE_STATUS_SELECTOR = {
  SELECT_STATUS: 'Seleccionar estado',
}
export const EVIDENCE_FILTERS = {
  ALL: 'Todos',
  FILTER_BY_OWNER: 'Filtrar por responsable',
  FILTER_BY_CLUSTER: 'Filtrar por cluster',
  FILTER_BY_STANDARD: 'Filtrar por estándar',
}

export const EVIDENCE_DRAWER = {
  DESCRIPTION: 'Descripción',
  EXTERNAL_LINKS: 'Enlaces Externos',
  LINKS_ADDED: 'Enlaces Agregados',
  FILES: 'Archivos',
  RELATED_CONTROLS: 'Controles Relacionados',
  MISSING_DESCRIPTION: 'Falta la descripción',
  UPLOAD_FILES: 'Subir Archivos',
  ADD_LINK: 'Agregar Enlace',
  ADD_LINK_LABEL: 'Etiqueta del Enlace',
  ADD_LINK_URL: 'URL del Enlace',
  EVIDENCE_UPDATED: 'Evidencia actualizada',
}

export const EVIDENCE_DETAIL = {
  ATTRIBUTES: 'Atributos',
  CONTENT: 'Contenido de la Evidencia',
  DESCRIPTION: 'Descripción de la Evidencia',
  MISSING_DESCRIPTION: 'Falta la descripción de la evidencia',
  RELATED_CONTROLS: 'Controles Relacionados',
  CUSTOM_FILE_UPLOAD: 'Subir Archivo Personalizado',
  ADD_CUSTOM_LINK: 'Agregar Enlace Personalizado',
  NO_FILES: 'Aún no se han subido archivos',
  DOWNLOAD_CONTENT: 'Última Versión',
  NEVER_UPDATED: 'Nunca actualizado',
  EVIDENCE_UPDATED: 'Evidencia actualizada',
  CUSTOM_LINKS: 'Enlaces Personalizados',
  CUSTOM_FILES: 'Archivos Personalizados',
  UPLOADED_AT: 'Subido el',
  FILE_NOT_FOUND: 'Archivo no encontrado',
  LINK_LABEL: 'Etiqueta',
  LINK_LABEL_PLACEHOLDER: 'ej., Documentación',
  LINK_URL: 'URL',
  LINK_URL_PLACEHOLDER: 'https://ejemplo.com',
  CANCEL: 'Cancelar',
  ADD_LINK: 'Agregar Enlace',
  NO_EXTERNAL_LINKS: 'No se han agregado enlaces externos',
  VIEW_IN_PLATFORM: 'Ver en la plataforma',
  PLATFORM_LINK_LOCKED: 'Si amplias tu alcance se desbloqueará esta evidencia., contáctanos para más información.',
}
